import { render, staticRenderFns } from "./horassetorcompetencia.vue?vue&type=template&id=3bec2a96&"
import script from "./horassetorcompetencia.vue?vue&type=script&lang=js&"
export * from "./horassetorcompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports